/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetSavedListsCounts$Request {
    userId: number;
}

export interface GetSavedListsCounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSavedListsCountsRequest = createAction<PayloadData<void, GetSavedListsCounts$Request>>('USER_CONTENT_COUNT__GET_SAVED_LISTS_COUNTS__REQUEST');
export const getSavedListsCountsSuccess = createAction<PayloadData<{ [key: string]: number; }, GetSavedListsCounts$Request>>('USER_CONTENT_COUNT__GET_SAVED_LISTS_COUNTS__SUCCESS');
export const getSavedListsCountsFailure = createAction<PayloadData<Error, GetSavedListsCounts$Request, true>>('USER_CONTENT_COUNT__GET_SAVED_LISTS_COUNTS__FAILURE');

export const getSavedListsCountsActions = [
    getSavedListsCountsRequest,
    getSavedListsCountsSuccess,
    getSavedListsCountsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSavedListsCounts = (meta: GetSavedListsCounts$Request, config?: GetSavedListsCounts$Config) => {
    return {
        CALL_API: {
            types: getSavedListsCountsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/contents/saved-lists/counts`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSavedSearchesCounts$Request {
    userId: number;
}

export interface GetSavedSearchesCounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSavedSearchesCountsRequest = createAction<PayloadData<void, GetSavedSearchesCounts$Request>>('USER_CONTENT_COUNT__GET_SAVED_SEARCHES_COUNTS__REQUEST');
export const getSavedSearchesCountsSuccess = createAction<PayloadData<{ [key: string]: number; }, GetSavedSearchesCounts$Request>>('USER_CONTENT_COUNT__GET_SAVED_SEARCHES_COUNTS__SUCCESS');
export const getSavedSearchesCountsFailure = createAction<PayloadData<Error, GetSavedSearchesCounts$Request, true>>('USER_CONTENT_COUNT__GET_SAVED_SEARCHES_COUNTS__FAILURE');

export const getSavedSearchesCountsActions = [
    getSavedSearchesCountsRequest,
    getSavedSearchesCountsSuccess,
    getSavedSearchesCountsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSavedSearchesCounts = (meta: GetSavedSearchesCounts$Request, config?: GetSavedSearchesCounts$Config) => {
    return {
        CALL_API: {
            types: getSavedSearchesCountsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/contents/saved-searches/counts`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

